import { useAppPath } from '../nav'
import { useWorkspaceAccount } from '../WorkspaceAccountProvider'
import { Button } from '../../components/ui/Button'

type Props = {
  onOpenLive?: () => void
}

/** Quick actions for Demo-only state. Hidden when Live exists (hero owns finance CTAs). */
export function QuickActions({ onOpenLive }: Props) {
  const appPath = useAppPath()
  const ws = useWorkspaceAccount()

  if (ws.hasLiveAccount) return null

  return (
    <section className="cp-quick-actions cp-quick-actions--broker" aria-label="Quick actions">
      <h2 className="cp-quick-actions__title">Quick Actions</h2>
      <div className="cp-quick-actions__grid">
        <Button type="button" variant="primary" onClick={onOpenLive}>
          Open Live Account
        </Button>
        <Button to={appPath('/app/accounts')} variant="secondary">
          Trading Accounts
        </Button>
        <Button to={appPath('/app/support')} variant="ghost">
          Support
        </Button>
      </div>
    </section>
  )
}
